import { MLHelper } from '@bimser/core';
import IconDelete from '@bimser/icons/16/delete';
import IconEdit from '@bimser/icons/16/edit';
import React from 'react';
import { IOption } from '../../entities';
import Styles from './assets/styles.scss';

export const OptionHeader = React.memo<any>(props => {
	const option: IOption = props.data.column.editorOptions.option;
	const hideEditOption: boolean = props.data.column.editorOptions.hideEditOption;
	const hideDeleteOption: boolean = props.data.column.editorOptions.hideDeleteOption;
	const readonly: boolean = props.data.column.editorOptions.readonly;
	const disabled: boolean = props.data.column.editorOptions.disabled;

	const onOptionDeleted: (deletedOption: IOption) => void =
		props.data.column.editorOptions.onOptionDeleted;
	const onClickEditOption: (option: IOption) => void =
		props.data.column.editorOptions.onClickEditOption;

	const title = MLHelper.getMLText(option.title);

	return (
		<div className={Styles.optionHeader}>
			<div
				className={Styles.title}
				title={title}
			>
				{title}
			</div>
			{!hideEditOption && !readonly && !disabled && (
				<IconEdit
					className={Styles.btn}
					width="16px"
					onClick={() => onClickEditOption(option)}
				/>
			)}
			{!hideDeleteOption && !readonly && !disabled && (
				<IconDelete
					className={Styles.btn}
					width="16px"
					onClick={() => onOptionDeleted(option)}
				/>
			)}
		</div>
	);
});
